import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Dialog/DialogUsage.mdx";
import DevGuidance from "../../Docs/Components/Dialog/DialogDevGuidance.mdx";

import Examples from "../../Docs/Components/Dialog/DialogExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Dialog"
            description="A dialog is a temporary, modal overlay that can provide contextual information and/or require user confirmation or input."
            apiSources={["azure-devops-ui/Components/Dialog/Dialog.Props.d.ts"]}
            examples={Examples}
            internalLinks={{"figma":"https://www.figma.com/file/Qabw0qnz8E6nJlTK7wBJnXQu/Header-area?node-id=2%3A817"}}
            status={{"design":"done","code":"done","docs":"done"}}
            usage={Usage}
            devGuidance={DevGuidance}
        />
    );
}
}
        
export default Page;